import { updateEmailWorkFlow } from "../../../../../actions/Utilities/EmailWorkFlow";
import { useMutation } from "react-query";
const useUpdateEmailWorkFlow = () => {
  return useMutation(updateEmailWorkFlow);
};
export default useUpdateEmailWorkFlow;
